import React from 'react';
import { TemplateAutocomplete } from './templateAutocomplete';
import { AutocompleteOption } from '../form/autocomplete';

interface TemplateLazyAutocompleteProps {
  id?: string;
  // entity endpoint name in /api/v2/{entity}/search
  entity: string;
  // contract path to store selected value (id/url/etc)
  path: string;
  // key to read selected object from templateBuilderEx (e.g., 'organization', 'campaignOrganizer')
  selectedKey?: string; // if omitted, uses `selected`
  // optional full object path in template (e.g., 'franchise'), cleared along with the value
  objectPath?: string;
  // label/placeholder i18n keys
  label?: string;
  placeholder?: string;
  // required/optional rules
  validation?: any;
  // function to build request body for search
  request: () => any;
  // map raw entity item -> autocomplete option
  getItem: (item: any) => AutocompleteOption | undefined;
  // returnField for Autocomplete
  returnField?: string;
  // onChange(path, value, selectedItem)
  onChange: (path: string, value: any, selected?: any) => void;
  // if true, do an initial search on mount (we default false for lazy)
  searchOnLoad?: boolean;
  // disabled state
  disabled?: boolean;
}

// Template autocomplete that does not search on load. The chosen value shows as a summary with
// Change, from the shared autocomplete.
export function TemplateLazyAutocompleteImpl(
  props: TemplateLazyAutocompleteProps
) {
  const {
    id,
    entity,
    path,
    selectedKey,
    objectPath,
    label,
    placeholder,
    validation,
    request,
    getItem,
    returnField,
    onChange,
    searchOnLoad = false,
    disabled = false
  } = props;

  const handleClear = () => {
    if (objectPath) {
      onChange(objectPath, null);
    }
    if (selectedKey) {
      onChange(selectedKey, null);
    }
  };

  return (
    <TemplateAutocomplete
      id={id}
      entity={entity}
      path={path}
      selected={selectedKey || 'selected'}
      label={label}
      placeholder={placeholder}
      validation={validation}
      onChange={onChange}
      onClear={handleClear}
      request={request}
      getItem={getItem}
      returnField={returnField}
      searchOnLoad={searchOnLoad}
      disabled={disabled}
    />
  );
}

export const TemplateLazyAutocomplete = TemplateLazyAutocompleteImpl;
